import ActionTypes from "../Actions/ActionTypes";

let initialState = {
  clientDashboardData: {},
  vendorDashboardData: {},
  guestDashboardData: {},
};

const DashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.CLIENT_DASHBOARD:
      state = { ...state, clientDashboardData: action.payload };
      break;
    case ActionTypes.VENDOR_DASHBOARD:
      state = { ...state, vendorDashboardData: action.payload };
      break;
    case ActionTypes.GUEST_DASHBOARD:
      state = { ...state, guestDashboardData: action.payload };
      break;

    default:
      break;
  }
  return state;
};

export default DashboardReducer;
